import axios from 'axios';
import router from "@/router"; //encapsulation

const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL || '/api',
    //baseURL: process.env.VUE_APP_BASEURL, //no need to switch anymore; this is the backend address
    //baseURL: 'http://18.168.72.252/api',  // attention！！ add '/api' to the global as pre, which means all the interfaces will have '/api' as pre, then there's no need to add it separately, otherwise will have two'/api', like '/api/api/user' error
    timeout: 5000
})

// ---------- request interceptor ----------
request.interceptors.request.use(
    (config) => {
        // attach JWT (your backend reads header "token")
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.token = token;
            // If you later switch backend to Authorization, use:
            // config.headers.Authorization = `Bearer ${token}`;
        }

        // set JSON Content-Type only when sending a plain object body
        const hasBody = config.data !== undefined && config.data !== null;
        const isJsonBody =
            hasBody &&
            !(config.data instanceof FormData) &&
            !(config.data instanceof URLSearchParams) &&
            !(config.data instanceof Blob) &&
            !(config.data instanceof ArrayBuffer);

        if (isJsonBody && !config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json;charset=utf-8';
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ---------- response interceptor ----------
request.interceptors.response.use(
    (response) => {
        // file download passthrough
        if (response.config.responseType === 'blob') {
            return response.data;
        }

        let res = response.data;

        // some backends return stringified JSON
        if (typeof res === 'string' && res) {
            try { res = JSON.parse(res); } catch (_) {}
        }

        // app-level auth fail using your { code, msg, data } envelope
        if (res && res.code === '401') {
            // optional: clear stale auth
            localStorage.removeItem('token');
            localStorage.removeItem('owner');

            if (router.currentRoute.path !== '/signin') {
                router.replace('/signin').catch(() => {});
            }
        }

        return res;
    },
    (error) => {
        // network/HTTP-level 401 (not wrapped in {code})
        if (error?.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('owner');
            if (router.currentRoute.path !== '/signin') {
                router.replace('/signin').catch(() => {});
            }
        }
        return Promise.reject(error);
    }
);

export default request;

